import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { toast } from 'sonner';
import { reviews } from '../lib/api';

const StarRating = ({ rating, setRating, label }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="flex gap-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => setRating(star)}
            className="transition-transform hover:scale-110"
          >
            <Star
              className={`w-8 h-8 ${
                star <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
              }`}
            />
          </button>
        ))}
        <span className="ml-2 text-gray-600 font-semibold">{rating}/5</span>
      </div>
    </div>
  );
};

const ReviewForm = ({ courseId, onSuccess }) => {
  const [teachingRating, setTeachingRating] = useState(5);
  const [contentsRating, setContentsRating] = useState(5);
  const [knowledgeRating, setKnowledgeRating] = useState(5);
  const [reviewText, setReviewText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await reviews.create({
        course_id: courseId,
        teaching_methodology_rating: teachingRating,
        course_contents_rating: contentsRating,
        teacher_knowledge_rating: knowledgeRating,
        review_text: reviewText,
      });
      toast.success('Review submitted successfully!');
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to submit review');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
      <h3 className="text-2xl font-bold text-gray-900 mb-6">Leave a Review</h3>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <StarRating
          rating={teachingRating}
          setRating={setTeachingRating}
          label="Teaching Methodology"
        />
        
        <StarRating
          rating={contentsRating}
          setRating={setContentsRating}
          label="Course Contents"
        />
        
        <StarRating
          rating={knowledgeRating}
          setRating={setKnowledgeRating}
          label="Teacher's Knowledge Level"
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your Review
          </label>
          <textarea
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
            rows="5"
            placeholder="Share your experience with this course..."
            required
            data-testid="review-text-input"
          />
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="w-full py-3 bg-black text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="submit-review-btn"
        >
          {submitting ? 'Submitting...' : 'Submit Review'}
        </button>
      </form>
    </div>
  );
};

export default ReviewForm;
